import React, { useEffect, useState, useMemo, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from '../../../context/UserContext.js';
import MensajeCargando from '../../UI/MensajeCargando.js';
import MensajeError from '../../UI/MensajeError.js';
import ElegirFechaEtapa from './ElegirFechaEtapa.js';
import PartidosEquipoTorneo from '../../tablas/PartidosEquipoTorneo.js';
import PartidosEtapaTorneo from '../../tablas/PartidosEtapaTorneo.js';
import PartidosFechaEtapa from '../../tablas/PartidosFechaEtapa.js';
import FixtureEtapaDefinicion from './FixtureEtapaDefinicion.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import { Partidos as TipoLista } from '../../constantes/Filtros.js';
import * as Funciones from '../../funciones/FuncionesTorneos.js';

const ListaPartidos = (props) => {
  const tipoLista = props.tipoLista;
  const datosElegidos = props.datosElegidos;
  const [partidos, setPartidos] = useState([]);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  const url = useMemo(() => {
    return Funciones.URLListaPartidos(tipoLista, datosElegidos);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoLista, datosElegidos.torneo, datosElegidos.etapa, datosElegidos.equipo]);

  useEffect(() => {
    if (url) {
      fetchData(url, setPartidos);
    } else {
      setPartidos([]);
    }
  }, [url, fetchData]);

  // Reset fecha when etapa changes
  useEffect(() => {
    setFechaSeleccionada(null);
  }, [datosElegidos.etapa]);

  const navigate = useNavigate();
  const onPartidoElegido = (idPartido) => {
    navigate('/partido/' + idPartido, { state: { datosElegidos } });
  };

  const onFechaElegida = (fecha) => {
    setFechaSeleccionada(fecha);
  };

  // Verificar si la etapa tiene fechas
  const etapaTieneFechas = datosElegidos.etapa && datosElegidos.etapa.cantidadFechas > 0;

  let lista = '';
  switch (tipoLista) {
    case TipoLista.TORNEO: {
      // Mostrar todos los partidos del torneo
      lista = (
        <PartidosEtapaTorneo
          etapa={null}
          categoria={datosElegidos.categoria}
          torneo={datosElegidos.torneo}
          partidos={partidos}
          onPartidoElegido={onPartidoElegido}
        />
      );
      break;
    }
    case TipoLista.EQUIPO: {
      lista = (
        <PartidosEquipoTorneo
          categoria={datosElegidos.categoria}
          equipo={datosElegidos.equipo}
          partidos={partidos}
          onPartidoElegido={onPartidoElegido}
        />
      );
      break;
    }
    case TipoLista.ETAPA: {
      // Si la etapa es de definición y el usuario puede editar, mostrar el componente de fixture
      const esDefinicion = datosElegidos.etapa?.definicion === true;

      if (esDefinicion && puedeEditar) {
        lista = <FixtureEtapaDefinicion datosElegidos={datosElegidos} />;
      } else if (etapaTieneFechas) {
        // Si la etapa tiene fechas, mostrar selector de fechas y filtrar partidos
        lista = (
          <React.Fragment>
            <ElegirFechaEtapa
              etapa={datosElegidos.etapa}
              fechaElegida={fechaSeleccionada}
              onFechaElegida={onFechaElegida}
            />
            <PartidosFechaEtapa
              fecha={fechaSeleccionada}
              partidos={partidos}
              categoria={datosElegidos.categoria}
              torneo={datosElegidos.torneo}
              onPartidoElegido={onPartidoElegido}
            />
          </React.Fragment>
        );
      } else {
        // Si no tiene fechas, mostrar todos los partidos de la etapa
        lista = (
          <PartidosEtapaTorneo
            etapa={datosElegidos.etapa}
            categoria={datosElegidos.categoria}
            torneo={datosElegidos.torneo}
            partidos={partidos}
            onPartidoElegido={onPartidoElegido}
          />
        );
      }
      break;
    }
    case TipoLista.FECHAS_ETAPA: {
      lista = (
        <React.Fragment>
          <ElegirFechaEtapa
            etapa={datosElegidos.etapa}
            fechaElegida={fechaSeleccionada}
            onFechaElegida={onFechaElegida}
          />
          <PartidosFechaEtapa
            fecha={fechaSeleccionada}
            partidos={partidos}
            categoria={datosElegidos.categoria}
            torneo={datosElegidos.torneo}
            onPartidoElegido={onPartidoElegido}
          />
        </React.Fragment>
      );
      break;
    }
    default: {
      throw new Error('Tipo de lista desconocido');
    }
  }

  return (
    <React.Fragment>
      {!isCargando && lista}
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default ListaPartidos;
